export class PieceJointe {
    constructor(
        public id?: number,
        public nom?: string,
        public conforme?: boolean,
        public notes?: string,
        public dateCreation?: any,
        public dateModification?: any,
        public dateConformite?: any,
        public pieceId?: number,
        public userId?: number,
        public candidatureFormationId?: number,
        public referentId?: number
    ) { }

    public static getPieceIndex(pieceId,referentId ) {
        if (referentId==null ) {
            return (String(pieceId)) ;
        }else{
            return (String(pieceId) + "_" + String(referentId)) ;
        }
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/piece-jointe/piece-jointe.model.ts